//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
import LocationsViewAll from '../../components/locations/LocationsViewAll.vue'

export default {
  data() {
    return {
      location: null
    }
  },
  head() {
    if (this.story) {
      return this.$metadata(this.story)
    }
  },
  computed: {
    isLocations() {
      return this.$route.path.replace(/\//g,'') == 'locations'
    },
    isSearchAll() {
      return this.$route.path.replace(/\//g,'') == 'locationsall'
    },
    isViewAll() {
      return !this.isLocations && !this.isDetails && !this.isSearchAll
    },
    isDetails() {
      let split = this.$route.path.split('/')
      let parts = []
      for (let i = 0; i < split.length; i++) {
        if (split[i] !== '') {
          parts.push(split[i])
        }
      }
      return parts.length == 4
    }
  },
  async validate({ $storyblok, params, store }) {
    try {
      let location = store.state.allLocations.find(l => {
        return l.path == params.pathMatch
      })
      if(location) {
        return true
      } else {
        // updated to get show all location page for /locations/state
        // let story = await $storyblok.getStory(`locations/${params.pathMatch}`)
        let path = `locations/view-all`
        if (params.pathMatch == '') {
          path = `locations/${params.pathMatch}`
        }
        let story = await $storyblok.getStory(path)
        if(story) {
          return true
        } else {
          return false
        }
      }
    } catch(err) {
      return false
    }
  },
  async asyncData({ store, $storyblok, params }) {
    let location = store.state.allLocations.find(l => {
      return l.path == params.pathMatch
    })
    if(location) {
      // Get sliders from homepage
      let home = await $storyblok.getStory(`home`)
      let section = null
      let callout = null
      let faqs = await $storyblok.getStory(`_globals/faqs`)
      faqs = faqs.content
      for (let i = 0; i < home.content.columns[0].body.length; i++) {
        section = home.content.columns[0].body[i]
        if (section.component == 'callout-section') {
          callout = section
        }
      }
      return {
        story: {
          content: location
        },
        location,
        callout,
        faqs
      }
    } else {
      let story = await $storyblok.getStory(`locations/${params.pathMatch}`)
      if(story) {
        return {
          story
        }
      }
    }
  }
}
